var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "md:w-1/3 xs:w-1/2 w-full xs:min-w-160px md:min-w-220px lg:max-w-220px md:px-10px px-7.5px md:pb-20px pb-15px",
    },
    [
      _c(
        "div",
        { staticClass: "w-full relative overflow-hidden shadow-lg" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show,
                    expression: "show",
                  },
                ],
                staticClass:
                  "border-4 rounded-10px w-full h-full absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 z-10",
                staticStyle: { "background-color": "rgba(50, 50, 50, 0.9)" },
              },
              [
                _c("div", { staticClass: "w-full h-full relative" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "js-toggle-download-modal block text-base text-white00 font-light cursor-pointer mb-20px",
                          attrs: { id: "projects-download" },
                          on: { click: _vm.openModalOverviewDownload },
                        },
                        [_vm._v("\n              ダウンロード\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "block text-base text-white00 font-light cursor-pointer",
                          attrs: { id: "projects-complate" },
                          on: { click: _vm.openModalOverviewComplete },
                        },
                        [_vm._v("\n              作業完了\n            ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "w-20px h-20px absolute top-10px right-10px",
                      on: {
                        click: function ($event) {
                          _vm.show = !_vm.show
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "relative w-full h-full cursor-pointer",
                        },
                        [
                          _c("div", {
                            staticClass:
                              "bg-white00 h-2px w-full absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 rotate-45",
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "bg-white00 h-2px w-full absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 -rotate-45",
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "absolute top-0 left-0 w-full h-full border-4 rounded-10px p-10px",
              class: ["status-border-" + _vm.project.progression],
            },
            [
              _c(
                "div",
                { staticClass: "flex justify-between sm:mb-20px mb-10px" },
                [
                  _c("div", { staticClass: "flex items-start" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "processing-manager sm:text-xs text-3xs sm:leading-loose leading-normal sm:w-2em w-1.5em mr-5px",
                        class: {
                          "manager-disabled":
                            _vm.project.processing_enabled == false,
                          "manager-downloaded":
                            _vm.project.processing_status == 1 ||
                            _vm.project.processing_status == 2,
                        },
                      },
                      [_vm._v("\n            " + _vm._s("加") + "\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "output-manager sm:text-xs text-3xs sm:leading-loose leading-normal sm:w-2em w-1.5em mr-5px",
                        class: {
                          "manager-disabled":
                            _vm.project.output_enabled == false,
                          "manager-downloaded":
                            _vm.project.output_status == 1 ||
                            _vm.project.output_status == 2,
                        },
                      },
                      [_vm._v("\n            " + _vm._s("出") + "\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "technical-manager sm:text-xs text-3xs sm:leading-loose leading-normal sm:w-2em w-1.5em mr-5px",
                        class: {
                          "manager-disabled":
                            _vm.project.technical_enabled == false,
                          "manager-downloaded":
                            _vm.project.technical_status == 1 ||
                            _vm.project.technical_status == 2,
                        },
                      },
                      [_vm._v("\n            " + _vm._s("技") + "\n          ")]
                    ),
                    _vm._v(" "),
                    _vm.project.affiliate_authored
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "affiliate-authored sm:text-xs text-3xs sm:leading-loose leading-normal sm:w-2em w-1.5em",
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s("外") + "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "block sm:w-20px w-16px sm:h-16px h-14px relative cursor-pointer",
                      on: {
                        click: function ($event) {
                          _vm.show = !_vm.show
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "h-2px w-full bg-black01 absolute top-0 left-1/2 transform -translate-x-1/2",
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "h-2px w-full bg-black01 absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2",
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "h-2px w-full bg-black01 absolute bottom-0 left-1/2 transform -translate-x-1/2",
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                { attrs: { href: "/projects/" + _vm.project.id + "/show" } },
                [
                  _c("div", { staticClass: "w-full relative" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "absolute top-0 left-0 sm:text-base text-xs text-black01 font-bold sm:h-45px h-35px mb-20px overflow-ellipsis overflow-hidden",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.project.name) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pt-2/5" }),
                  ]),
                  _vm._v(" "),
                  _c("hr", {
                    staticClass: "border-t-2 border-dashed border-grey03",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "pt-5px" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("div", [
                          _c(
                            "span",
                            {
                              staticClass:
                                "sm:text-base text-xs text-black01 font-bold relative",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "w-20px h-20px rounded-20px absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2",
                                class: [_vm.amBackgroundColor],
                              }),
                              _vm._v("\n                AM\n              "),
                            ]
                          ),
                          _vm._v("\n              ·\n              "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "sm:text-base text-xs text-black01 font-bold relative",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "w-20px h-20px rounded-20px absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2",
                                class: [_vm.pmBackgroundColor],
                              }),
                              _vm._v("\n                PM\n              "),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sm:text-base text-xs text-white00 font-bold px-10px py-5px rounded-20px",
                            class: ["type-bg-" + _vm.project.type],
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.project.type_string) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sm:text-base text-xs text-black01 font-bold",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.formatISODate(
                                _vm.project.due_date,
                                "MMMdo EEEEE"
                              )
                            ) +
                            "\n            " +
                            _vm._s(
                              _vm.project.type == 0
                                ? _vm.formatISODate(
                                    this.parseToISOString(
                                      this.project.due_time,
                                      "HH:mm",
                                      new Date()
                                    ),
                                    "a HH:mm",
                                    "en"
                                  )
                                : _vm.project.due_time_period == 0
                                ? "AM"
                                : "PM"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pt-full" }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }